import { Accordion, Title } from '@panwds/react-ui'
import UTSGCreateTree from './UTSGCreateTree'
import AccordionPanel from './AccordionPanel/AccordionPanel'
import { useMemo } from 'react'
import ActivationBanner from '../common/ActivationBanner'
import { isDefaultTsgFeaturesEnabled, StringTemplate } from '../common/utils'

type AccordionDataType = {
  title: string
  text: string
}

const accordionData: AccordionDataType[] = [
  {
    title: 'What is a tenant',
    text: 'A tenant is a logical container for a group (e.g., company, business unit, region, or geographical location) where you can separately manage and monitor the products and licenses in a subscription. An admin can see products and data in their own tenant and all of its subtenants.'
  },
  {
    title: 'What is a sub-tenant',
    text: 'Any tenant nested under another tenant is its subtenant. You can add subtenants to separately manage and monitor products and licenses in the same hierarchy, such as for subsidiaries or business units.'
  },
  {
    title: 'Can I create more tenants/sub-tenants?',
    text: 'A subscription gets activated on a single tenant or subtenant. After it\'s active and provisioned with the instances of your products, you can then build out your tenant hierarchy further as needed.'
  }
]

const defaultBannerMessage = 'We\'ve picked \'{0}\' as the recipient tenant to match the Customer Support Account name. If you\'d like to activate the product in a different tenant, you can rename the recipient tenant or click on the + icon to create a new subtenant.'

const UTSGNew = (props: any) => {
  const { tsgName, showBanner, state } = props
  const enableDefaultTsgFeatures = isDefaultTsgFeaturesEnabled(state)
  const LearnAboutTenants = useMemo(() => (
    <div className='cm-max-w-[500px]'>
      <Accordion
        defaultOpenPanels={[0]}>
        {accordionData.map((each: AccordionDataType, index: number) => {
          const title = <Title level={4} size='xs'>{each.title}</Title>
          return (<AccordionPanel
            addClassName='cm-bg-[#F4F5F5]'
            as='div'
            key={index}
            title={title}
            indicator={true}>
            {each.text}
          </AccordionPanel>)
        })}
      </Accordion>
    </div>), [])

  const bannerMessage = StringTemplate(defaultBannerMessage, [tsgName])

  return (
    <>
      {enableDefaultTsgFeatures && showBanner && <ActivationBanner infoMessage={bannerMessage} appearance='standard' type='inline' />}
      <div className='cm-flex cm-justify-between'>
        <UTSGCreateTree {...props} />
        {!enableDefaultTsgFeatures && LearnAboutTenants}
      </div>
    </>
  )
}

export default UTSGNew
